/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useStyles from '../useStyles';
import Typography from '../../../../components/Typography/Typography';
import PaperContainer from '../../../../components/PaperContainer/PaperContainer';
import SizeDetail from './SizeDetail';
import ElectricalDetail from './ElectricalDetail';

const targetPageType = {
  SIZE: 1,
  ELECTRICAL: 2,
};

/**
 * SinteringDetail 元件顯示燒結尺寸、電性檢驗資料，提供尺寸量測與電性量測之間的分頁導覽功能。
 *
 * @component
 * @param {Object} props - 元件屬性
 * @param {Object} props.renderData - 包含燒結尺寸、電性量測資料的渲染資料
 * @param {Object} props.renderData.sinteringSize - 尺寸量測資料
 * @param {Object} props.renderData.sinteringElectrical - 電性量測資料
 * @param {Object} props.specData - 規格設定資料
 * @param {Object} props.specData.sinteringSize - 尺寸規格設定
 * @param {Object} props.specData.sinteringElectrical - 電性規格設定
 * @param {boolean} props.specData.isRStick - 標示是否為 R棒
 * @param {boolean} props.isLoading - 載入狀態指示器
 * @param {Object} props.resultMetadata - 結果元件
 * @param {boolean} props.resultMetadata.isManualPassElec - 電性檢驗是否手動通過
 * @param {boolean} props.resultMetadata.isManualPassSize - 尺寸檢驗是否手動通過
 * @param {string} props.resultMetadata.elecComment - 電性檢驗備註
 * @param {string} props.resultMetadata.sizeComment - 尺寸檢驗備註
 * @returns {JSX.Element}
 */

const SinteringDetail = ({ renderData, specData, isLoading, resultMetadata }) => {
  const { sinteringSize, sinteringElectrical } = renderData;
  const {
    sinteringSize: sizeSpecConfig,
    sinteringElectrical: electricalSpecConfig,
    isRStick,
  } = specData;
  const [targetPage, setTargetPage] = useState(targetPageType.SIZE);
  const { classes } = useStyles();

  return (
    <div className={classes.detail_table}>
      <PaperContainer className={classes.detail_nav}>
        <Typography
          variant="body1"
          className={`${classes.detail_nav_item} ${
            targetPage === targetPageType.SIZE ? 'active' : ''
          }`}
          onClick={() => setTargetPage(targetPageType.SIZE)}
        >
          尺寸
        </Typography>
        <Typography
          variant="body1"
          className={`${classes.detail_nav_item} ${
            targetPage === targetPageType.ELECTRICAL ? 'active' : ''
          }`}
          onClick={() => setTargetPage(targetPageType.ELECTRICAL)}
        >
          電性
        </Typography>
      </PaperContainer>
      {targetPage === targetPageType.SIZE && (
        <SizeDetail
          sinteringSize={sinteringSize}
          sizeSpecConfig={sizeSpecConfig}
          isLoading={isLoading}
          resultMetadata={{
            isManualPassSize: resultMetadata.isManualPassSize,
            sizeComment: resultMetadata.sizeComment,
          }}
        />
      )}
      {targetPage === targetPageType.ELECTRICAL && electricalSpecConfig && sinteringElectrical && (
        <ElectricalDetail
          sinteringElectrical={sinteringElectrical}
          electricalSpecConfig={electricalSpecConfig}
          isRStick={isRStick}
          isLoading={isLoading}
          resultMetadata={{
            isManualPassElec: resultMetadata.isManualPassElec,
            elecComment: resultMetadata.elecComment,
          }}
        />
      )}
    </div>
  );
};

SinteringDetail.propTypes = {
  renderData: PropTypes.object.isRequired,
  specData: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  resultMetadata: PropTypes.object.isRequired,
};

export default SinteringDetail;
